// extracted by mini-css-extract-plugin
export default {"Carousel":"styles_Carousel__LiuBq","item":"styles_item__cTJ95"};